import BasicText from "./BasicText";
import GithubIcon from "./svg/GithubIcon";
import LuminodeLogo from "./LuminodeLogo";
import XLogo from "./svg/XLogo";
import FarcasterLogo from "./svg/FarcasterLogo";

function Feet() {
  return (
    <div className="flex flex-col xl:flex-row w-full xl:w-[1200px] items-start justify-between py-[59px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0 gap-[20px]">
      <div className="flex flex-col">
        <LuminodeLogo />
        <BasicText color={"faded"} className={'text-[14px] pt-[12px] max-w-[360px]'}>
          A venture development studio building enterprise-grade solutions for the global onchain economy.
        </BasicText>
        <div className="flex flex-row gap-[24px] pt-[28px]">
          <XLogo />
          <GithubIcon />
          <FarcasterLogo />
        </div>
      </div>
      {/*
      <BasicText className={'text-[14px] tracking-wider font-light'}>
        <div className="flex flex-col xl:flex-row gap-[30px] xl:gap-[110px]">
          <div className="flex flex-col gap-[12px]">
            <a href='#'>Home</a>
            <a href='#' className="text-[#848895]">Grants</a>
            <a href='#' className="text-[#848895]">Break Solana</a>
            <a href='#' className="text-[#848895]">Media Kit</a>
          </div>
          <div className="flex flex-col gap-[12px]">
            <a href='#'>Home</a>
            <a href='#' className="text-[#848895]">Grants</a>
            <a href='#' className="text-[#848895]">Break Solana</a>
            <a href='#' className="text-[#848895]">Media Kit</a>
          </div>
          <div className="flex flex-col gap-[12px]">
            <a href='#'>Home</a>
            <a href='#' className="text-[#848895]">Grants</a>
            <a href='#' className="text-[#848895]">Break Solana</a>
            <a href='#' className="text-[#848895]">Media Kit</a>
          </div>
        </div>
  </BasicText>*/}
    </div>
  );
}

export default Feet;